"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide5 = exports.HomepageSlide5 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide5 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: block;
        width: 100%;
        max-width: var(--slide-max-width, 100%);
        margin: 5rem auto;
        box-sizing: border-box;
        
        font-family: 'quaaykop-medium', sans-serif;
      }
      
      @keyframes title {
        from { opacity: 0; transform: translateX(200px); }
        to { opacity: 1; transform: translateY(0); }
      }
      div.title {
        font-size: 2.6rem;
        font-weight: 700;
        color: rgb(159, 111, 40);
        margin-bottom: 1rem;
        
        animation: title linear;
        animation-timeline: view();
        animation-range: entry 0% entry 300%;
        animation-fill-mode: both;
      }
      
      div.content {
        width: 100%;
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-gap: 1rem;
        box-sizing: border-box;
      }
      
      @keyframes animate-cell-1 {
        from { opacity: 0; transform: translate(-200px, -200px); }
        to { opacity: 1; transform: translate(0, 0); }
      }
      div.content div.cell-1 {
        width: 100%;
        aspect-ratio: 3 / 2;
        position: relative;
        box-sizing: border-box;
        background-color: white;
        
        animation: animate-cell-1 linear;
        animation-timeline: view();
        animation-range: entry 0% entry 80%;
        animation-fill-mode: both;
      }
      
      div.content div.cell-1 div.front-layer {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        box-sizing: border-box;
        
        view-timeline-name: --cell-1-slide-timeline;
        view-timeline-axis: block;
      }
      
      div.content div.cell-1 div.front-layer:hover {
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
      }
      
      div.content div.cell-1 div.front-layer img {
        width: 100%;
        height: auto;
      }
      
      div.content div.cell-1 div.front-layer div.cell-1-title {
        color: black;
        font-size: 2.2rem;
        margin: 0.8rem 0.8rem;
        
        animation: title linear;
        animation-timeline: --cell-1-slide-timeline;
        animation-range: entry 0% entry 80%;
        animation-fill-mode: both;
      }
      
      div.content div.cell-1 div.front-layer div.cell-1-content {
        font-size: 1.52rem;
        margin: 0 0.8rem;
        
        animation: title linear;
        animation-timeline: --cell-1-slide-timeline;
        animation-range: entry 0% entry 80%;
        animation-fill-mode: both;
      }
      
      div.content div.cell-1 div.back-layer {
        width: 100%;
        height: 100%;
        background-image: url('/files/assets/images/slide-5-cell-1-back.jpg');
        background-position: center;
        background-size: cover;
      }
      
      @keyframes animate-cell-2 {
        from { opacity: 0; transform: translate(200px, -200px); }
        to { opacity: 1; transform: translate(0, 0); }
      }
      div.content div.cell-2 {
        width: 100%;
        height: 100%;
        background-image: url('/files/assets/images/slide-5-cell-2.jpg');
        background-size: 100%;
        
        animation: animate-cell-2 linear;
        animation-timeline: view();
        animation-range: entry 0% entry 80%;
        animation-fill-mode: both;
      }
      
      @keyframes animate-cell-3 {
        from { transform: translateY(200px); }
        to { transform: translateY(0); }
      }
      div.content div.cell-3 {
        grid-column: 1 / 3;
        background-color: #D7C0A0;
        color: white;
        padding: 3rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: center;
        
        animation: animate-cell-3 linear;
        animation-timeline: view();
        animation-range: entry 0% entry 40%;
        animation-fill-mode: both;
      }
      
      div.content div.cell-3 div.cell-3-title {
        font-size: 2.5rem;
        margin: 0.8rem 0;
        
        /*animation: title linear;*/
        /*animation-timeline: view();*/
        /*animation-range: entry 0% entry 300%;*/
        /*animation-fill-mode: both;*/
      }
      
      div.content div.cell-3 div.cell-3-content {
        font-size: 1.6rem;
        
        /*animation: title linear;*/
        /*animation-timeline: view();*/
        /*animation-range: entry 0% entry 300%;*/
        /*animation-fill-mode: both;*/
      }
      
      div.content div.cell-3 video {
        width: 90%;
        object-fit: contain;
      }
      
      @media (max-width: 600px) {
        :host {
          margin: 1rem auto;
          padding: 2rem 1rem;
        }
        
        div.title {
          font-size: 2rem;        
        }
        div.content {
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
        }
        
        div.content div.cell-1 {
          width: 100%;
          height: auto;
        }
        
        div.content div.cell-1 div.front-layer {
          position: static;
          padding: 0;
        }
        
        div.content div.cell-1 div.front-layer div.cell-1-title {
          font-size: 1.4rem;
        }
        
        div.content div.cell-1 div.front-layer div.cell-1-content {
          font-size: 1rem;
        }
        
        div.content div.cell-1 div.back-layer {
          display: none;
        }
        
        div.content div.cell-2 {
          display: none;
        }
        
        div.content div.cell-3 {
          padding: 1rem;
          gap: 1rem;
        }
        
        div.content div.cell-3 div.cell-3-title {
          font-size: 1.4rem;
          margin: 1rem 0;
        }
        
        div.content div.cell-3 div.cell-3-content {
          font-size: 1.1rem;
        }
        
        div.content div.cell-3 video {
          width: 100%;
        }
      }
    </style>
    <div class="title">AiLEENE Technology</div>
    <div class="content">
      <div class="cell-1">
        <div class="front-layer">
          <img src="/files/assets/images/slide-5-cell-1-front.jpg" />
          <div class="cell-1-title">
            AiLEENE is properly hydrated to prevent swelling and edema after procedure
          </div>
          <div class="cell-1-content">
            If HA dermal filler is not hydrated sufficiently, it absorbs the moisture of surrounding tissues rapidly through osmotic pressure, in consequence causing swelling and edema. Measuring the hydration of HA dermal fillers will help to determine the product safety and predict outcome of the procedure.
          </div>
        </div>
        <div class="back-layer">
        
        </div>
      </div>
      <div class="cell-2"></div>
      <div class="cell-3">
        <div class="cell-3-title">
          AiLEENE melts fast by hyaluronidase and hardly remaining any residue
        </div>
        <div class="cell-3-content">
          Stick to the basics of Hyaluronic acid filler, AiLEENE reacts sensitively to Hyaluronidase making it prone to melting by its high-purity that made with pure ingredients and finely controlled manufacturing process
        </div>
        <video autoplay muted loop playsinline>
          <source src="/files/assets/videos/slide-5-melting-speed.mp4">
        </video>
      </div>
    </div>
    `;
    }
}
exports.HomepageSlide5 = HomepageSlide5;
const defineHomepageSlide5 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide5);
};
exports.defineHomepageSlide5 = defineHomepageSlide5;
